import { render, staticRenderFns } from "./AccountSettings.vue?vue&type=template&id=11dbdccd&"
import script from "./AccountSettings.vue?vue&type=script&lang=ts&"
export * from "./AccountSettings.vue?vue&type=script&lang=ts&"
import style0 from "./AccountSettings.vue?vue&type=style&index=0&id=11dbdccd&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports